import React, { createContext, useContext, useState, ReactNode } from "react";

interface AccountSettingsModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const AccountSettingsModalContext = createContext<
  AccountSettingsModalContextType | undefined
>(undefined);

export const AccountSettingsModalProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <AccountSettingsModalContext.Provider
      value={{ isOpen, openModal, closeModal }}
    >
      {children}
    </AccountSettingsModalContext.Provider>
  );
};

export const useAccountSettingsModal = () => {
  const context = useContext(AccountSettingsModalContext);
  if (!context) {
    throw new Error(
      "useAccountSettingsModal must be used within AccountSettingsModalProvider",
    );
  }
  return context;
};
